<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
export default {
  name: 'app'
}
</script>

  
<style lang="scss">
  @import '../../scss/variable.scss';
  @import '../../scss/app.scss';
  @import '../../scss/pages.scss';
  @import '../../scss/sidebar.scss';
  @import '../../scss/icons/font-awesome/css/font-awesome.min.css';
  @import '../../scss/icons/simple-line-icons/css/simple-line-icons.css';
  @import '../../scss/icons/weather-icons/css/weather-icons.min.css';
  @import '../../scss/icons/linea-icons/linea.css';
  @import '../../scss/icons/themify-icons/themify-icons.css'; 
  @import '../../scss/icons/flag-icon-css/flag-icon.min.css';
  @import '../../scss/icons/material-design-iconic-font/css/materialdesignicons.min.css';
  @import '../../scss/widgets.scss';
  @import '../../scss/grid.scss';
  @import '../../scss/responsive.scss'; 
  @import '../../scss/material.scss';
  @import '../../scss/custom.scss';
  @import '../../scss/colors/green.scss';
  .__cov-progress {
    height: 5px !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue